import React, { useContext, useEffect } from "react";
import { vestedShares, FoundersType, ResultContext } from "../ResultContext";
import { DecimalInput } from "./DecimalInput";
import { GivenQuestions } from "../constants/Questions";

export function VestingSharesInput({ questionId }: { questionId: number }) {
  const { result, setResult } = useContext(ResultContext);

  const currentQuestion = GivenQuestions.find((q) => q.id === questionId) as {
    dependsOn: number;
  };

  const dependsOn = currentQuestion.dependsOn as number;

  const dependsOnResult =
    (result[dependsOn] as {
      name: string;
      type: FoundersType;
    }[]) || [];

  const foundResult =
    (result[questionId] as vestedShares) ||
    Array.from({ length: dependsOnResult.length }, () => {
      return { vestedOptions: "all", vestedShares: "" };
    });

  useEffect(() => {
    if (!result[questionId]) {
      const copy = { ...result };

      copy[questionId] = Array.from({ length: dependsOnResult.length }, () => {
        return { vestedOptions: "all", vestedShares: "" };
      });

      setResult(copy);
    }
    // eslint-disable-next-line
  }, [questionId]);

  if (dependsOnResult.length > foundResult.length) {
    const diff = dependsOnResult.length - foundResult.length;

    for (let i = 0; i < diff; i++) {
      foundResult.push({ vestedOptions: "all", vestedShares: "" });
    }
  }

  return (
    <div className="flex flex-column">
      {dependsOnResult.length === 1 && dependsOnResult[0].name === ""
        ? null
        : dependsOnResult.map((item, index) => {
            return (
              <div
                className={`${
                  index !== 0 ? "flex flex-column mt-4" : "flex flex-column"
                }`}
              >
                <div className="sub-question small"> {item.name} </div>
                <label>How much of your shares are subject to vesting</label>
                <select
                  className="wider"
                  value={foundResult[index].vestedOptions}
                  onChange={(e) => {
                    const copy = { ...result };

                    copy[questionId] = foundResult.map((it, id) => {
                      if (id === index) {
                        return {
                          ...it,
                          vestedOptions: e.target.value,
                        };
                      }

                      return it;
                    });

                    setResult(copy);
                  }}
                >
                  <option value="all">All</option>
                  <option value="percentage">Percentage</option>
                </select>
                {foundResult[index].vestedOptions === "percentage" ? (
                  <div>
                    <label>Percentage of your shares</label>
                    <DecimalInput
                      value={foundResult[index].vestedShares}
                      min={0}
                      max={100}
                      percentage={true}
                      onChange={(e) => {
                        const copy = { ...result };

                        copy[questionId] = foundResult.map((it, id) => {
                          if (id === index) {
                            return {
                              ...it,
                              vestedShares: e,
                            };
                          }

                          return it;
                        });

                        setResult(copy);
                      }}
                    />
                  </div>
                ) : null}
              </div>
            );
          })}
    </div>
  );
}
